<template lang="pug">

transition(name="modal")
  .vue-modal-mask
    .modal-con
      .modal
        .modal-header
          a.btn.btn-danger(@click="$emit('closedAddDealModal')") Close
        .modal-content
          .group
            select(v-model="newDeal.provider")
              option(value="") Select a Related Business
              option(v-for="bus in filteredAndOrderedBus" :key="bus['.key']" :value="bus['.key']") {{bus.name}}
            label Sponsor
          .group
            input#exampleInputPassword1.form-control(v-model="newDeal.title" type="text" placeholder="Deal Title")
            span.highlight
            span.bar
            label Deal Title
          .group
            select(v-model="newDeal.status")
              option(value="" selected="selected") Choose a Status
              option(value="draft") draft
              option(value="disabled") disabled
              option(value="live") live
            label Status
          .group.img-preview(v-if="newDeal.image")
            img.image-cover(:src="newDeal.image" alt="")
            label Cover Image (6x2):
          .group(v-show="!newDeal.image")
            input#uploadercover(@change="uploadDealImg" type="file")
          .group
            textarea.form-control(v-model="newDeal.desc" name="")
            span.highlight
            span.bar
            .label Description
          a.btn(@click="addDeal()") Add Deal
        .modal-header.vue-modal-footer

</template>

<script>
import { db, storehouse } from '../firebase-config.js'

export default {
  name: 'modal-enter',
  data() {
    return {
      scrollPosition: 0,
      newDeal: {
        timestamp: Date.now(),
        provider: '',
        title: '',
        desc: '',
        image: '',
        valid_start: '',
        valid_end: '',
        promo_code: '',
        status: ''
      }
    }
  },
  firebase() {
    return {
      dealsref: db.ref('deals'),
      dealsrel: db.ref('dealsRel'),
      businesses: db.ref('businesses')
    }
  },
  methods: {
    addDeal() {
      var test = this.$firebaseRefs.dealsref.push(this.newDeal).getKey()
      this.$firebaseRefs.dealsrel.child(this.newDeal.provider).child(test).set(true)
      this.newDeal.title = ''
      this.newDeal.provider = ''
      this.newDeal.desc = ''
      this.newDeal.image = ''
      this.currentUpload = 0
      this.newDeal.start = ''
      this.newDeal.end = ''
      this.newDeal.code = ''
      this.newDeal.status = ''
      this.$emit('closedAddDealModal')
    },
    uploadDealImg(e) {
      var uploadercover = document.getElementById('uploadercover')
      // Get File
      var file = e.target.files[0]
      // create a storage ref
      var fixedName = this.removeSymbols(this.newDeal.title)
      var storageRef = storehouse.ref('uploads/deals/' + fixedName + '/' + file.name)
      // Upload File
      var task = storageRef.put(file)
      let that = this
      // Update Progress Bar
      task.on('state_changed', function progress(snapshot) {
        var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        that.currentUpload = percentage
        uploadercover.style = 'width="' + percentage + '"'
      }, function () {
        var downloadURLcover = task.snapshot.downloadURL
        that.newDeal.image = downloadURLcover
      })
    },
    removeSymbols(stuff) {
      let t = stuff.replace(/\W/g, '').toLowerCase()
      return t
    }
  },
  computed: {
    error() {
      return this.$store.state.error
    },
    loading() {
      return this.$store.state.loading
    },
    displayName() {
      return this.$store.state.user.displayName
    },
    filteredAndOrderedBus() {
      return this.businesses.slice().sort(function (a, b) { return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0) })
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  },
  mounted() {
    let test = window.pageYOffset
    this.scrollPosition = test
    document.body.style.position = 'fixed'
    document.body.style.top = -test + 'px'
    document.body.style.overflowX = 'hidden'
  },
  destroyed() {
    document.body.style.position = ''
    document.body.style.overflowX = ''
    window.scrollTo(0, this.scrollPosition)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.modal {
  overflow: scroll;
}

h4 {
  font-size: 24px !important;
}

form {
  visibility: visible;
}

form {
  width: 100%;
  margin: 45px auto;
}

.modal-content {
  padding: 0 50px;
}

.group {
  position: relative;
  margin: 45px 0;
}

textarea {
  resize: none;
}

input, textarea {
  background: none;
  color: muted-color;
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid muted-color;

  &:focus {
    outline: none;
  }

  &:focus ~ label, &:valid ~ label {
    top: -14px;
    font-size: 12px;
    color: white;
  }

  &:focus ~ .bar:before {
    width: 100%;
  }
}

input[type='password'] {
  letter-spacing: 0.3em;
}

label {
  color: #ffffff50;
  font-size: 16px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 10px;
  transition: $trans-time ease all;
}

.bar {
  position: relative;
  display: block;
  width: 100%;

  &:before {
    content: '';
    height: 2px;
    width: 0;
    bottom: 0px;
    position: absolute;
    background: gold;
    transition: 0.5s ease all;
    left: 0%;
  }
}

h4 {
  font-size: 50px;
  font-family: lobster;
}

.btn {
  color: white !important;
  font-size: 18px !important;
}

.modal-header {
  display: flex;
  justify-content: flex-end;
}

.notes {
  color: #F1C40F;
  font-weight: bold;
}

.time {
  white-space: nowrap;
}

.detail-item {
  font-size: large;
  border-bottom: 1px dashed white;
  padding: 5px;
  white-space: wrap;

  i {
    color: #F1C40F;
    margin-right: 10px;
  }
}

.details {
  display: flex;

  @media only screen and (max-width: 500px) {
    display: block;
    width: 100%;
  }
}

.details-left, .details-right {
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 1em;

  @media only screen and (max-width: 500px) {
    width: 100%;
    border-right: none !important;
    height: auto;
  }
}

.details-left {
  border-right: 1px dashed white;
}

#show-modal {
  margin-top: 100px;
  margin-left: auto;
  margin-right: auto;
}

.vue-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.vue-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.vue-modal-container {
  width: auto;
  max-width: 25%;
  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 2px;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.vue-modal-footer {
  width: 100%;
  min-height: 20px;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: flex-end;

  div {
    display: flex;

    a {
      margin-right: 15px;
    }
  }

  a {
    font-size: medium;
  }
}

.vue-modal-default-button {
  float: right;
}

#unsupported-banner {
  z-index: 999999;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: #ea3030;
  width: 100%;
  border-bottom: 1px solid #EEEEEE;
  padding: 10px;
  box-sizing: border-box;
  transform: translateY(-150%);
  color: #FFFFFF;
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  animation: vue-banner-slide-in 0.8s ease forwards;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container, .modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@keyframes vue-banner-slide-in {
  0% {
    transform: translateY(-150%);
  }

  100% {
    transform: translateY(0%);
  }
}

html {
  overflow: hidden !important;
}

.overlayish {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    0,
    0,
    0,
    0.5
  );
}
</style>
